<template>
  <div class="page-content pr">
    <transition name="fade">
      <div>
        <div class="page-box">
          <div class="tr">
            <el-button type="primary" @click="addTypeButton" v-pms="'add'">+ 新建</el-button>
          </div>
          <el-table
            :data="tableData"
            v-loading="loading">
            <el-table-column
              prop="name"
              label="员工级别">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="110">
              <template slot-scope="{row}">
                <el-button type="text" @click="editTypeButton(row)" v-pms="'edit'">编辑</el-button>
                <el-button type="text" @click="deleteType(row)" v-pms="'del'">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </transition>
    <el-dialog
      :title="editMsg"
      :visible.sync="dialogFormVisible"
      v-if="dialogFormVisible"
      :modal="false"
      :v-loading="submitting">
      <div class="add-form">
        <el-form
          ref="form"
          :model="typeData"
          label-width="94px"
          :rules="rules">
          <el-form-item prop="name" label="员工级别">
            <el-input v-model="typeData.name" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input class="el-input"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                      v-model="typeData.remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="width: 100px;">关 闭</el-button>
        <el-button type="primary" @click="submitType" style="width: 100px;">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {employee} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE, USER_ID} from '../../constants'
export default {
  name: 'EmployeeType',
  created () {
    //  this.callback = () => this.getData()
    // this.$bus.$on('dataUpdate', this.callback)
  },
  destroyed () {
    // this.$bus.$off('dataUpdate', this.callback)
  },
  data () {
    return {
      orgCode: getSession(ORG_CODE),
      userId: getSession(USER_ID),
      tableData: [],
      loading: false,
      submitting: false,
      editMsg: '',
      dialogFormVisible: false,
      typeData: {
        typeId: '',
        name: '',
        remark: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入员工级别名称', trigger: 'blur'},
          {max: 32, message: '长度不能超过32个字符', trigger: 'blur'}
        ],
        remark: [
          {message: '请输入员工级别备注', trigger: 'blur'},
          {max: 255, message: '长度不能超过255个字符', trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      let {data} = await employee.getTypeList({orgCode: this.orgCode})
      this.tableData = data
      this.loading = false
    },
    submitType () { // 添加编辑
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.typeData.typeId) {
            this.addType()
          } else {
            this.editType()
          }
        } else {
          return false
        }
      })
    },
    async addType () { // 添加方法
      this.submitting = true
      this.typeData.orgCode = this.orgCode
      this.typeData.createUser = this.userId
      let {code, data, msg} = await employee.addEmployeeType(this.typeData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '员工级别添加成功'
        })
        this.getData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '员工级别添加失败'
        })
      }
    },
    async editType () { // 编辑方法
      this.submitting = true
      this.typeData.updateUser = this.userId
      let {code, msg} = await employee.editEmployeeType(this.typeData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '员工级别修改成功'
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '员工级别修改失败'
        })
      }
    },
    addTypeButton () {
      this.editMsg = '添加级别'
      this.typeData = {}
      this.dialogFormVisible = true
    },
    editTypeButton (data) {
      this.editMsg = '编辑级别'
      this.typeData = data
      this.dialogFormVisible = true
    },
    deleteType (typeItem) {
      this.$confirm(`确定要删除【${typeItem.name}】吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {data} = await employee.validIsExist({
          typeId: typeItem.typeId
        })
        if (data) {
          let {code} = await employee.delEmployeeType({typeId: typeItem.typeId})
          if (code === 0) {
            this.$message({
              type: 'success',
              message: `【${typeItem.name}】删除成功`
            })
            this.getData()
          } else {
            this.$message({
              type: 'error',
              message: `【${typeItem.name}】删除失败`
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: `【${typeItem.name}】下面存在员工使用,不能删除`
          })
        }
      }, err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-form {
    margin: 0 auto;
    width: 300px
  }
  .el-input {
    width: 240px
  }
</style>
